import { configureStore } from "@reduxjs/toolkit";
import updateUserData from './reducers/user';
import updateMyAddress from "./reducers/myAddress"
import updateCategories from "./reducers/allCategories"
import updateAuth from "./reducers/loginData"
import updateOrderData from "./reducers/orderData"
import updateGiftOrderData from "./reducers/giftOrderData"
import updateOrderSummary from "./reducers/orderSummary"
import loader from "./reducers/loader";
import trigger from "./reducers/trigger";
import snackbar from "./reducers/snackbar";
export default configureStore({
  reducer: {
    updateMyAddress:updateMyAddress,
    updateUserData:updateUserData,
    updateCategories:updateCategories,
    updateAuth:updateAuth,
    updateOrderData:updateOrderData,
    updateOrderSummary:updateOrderSummary,
    loader:loader,
    trigger:trigger,
    snackbar:snackbar,
    updateGiftOrderData:updateGiftOrderData
  },
});
